import React from 'react';
import { IconProps } from './model/IconInterface';

interface ArrowIconProps extends IconProps {
  position?: 'left' | 'right' | 'top' | 'bottom';
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ size = 20, color = 'currentColor', fill, position }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      style={{
        transform:
          position === 'left' ? 'rotate(180deg)' :
            position === 'top' ? 'rotate(-90deg)' :
              position === 'bottom' ? 'rotate(90deg)' : undefined
      }}
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
};

export default ArrowIcon;
